import React from "react";
import { Button } from '../PSY/Button'
import { useNavigate } from "react-router-dom";

export const NoDeposit: React.FC = props => {
  const navigate = useNavigate();

  return (
    <div className="bg-component border-component py-16 flex flex-col items-center h-full">
      <div className="text-style-value mt-6">You have no SLSD in the Stability Pools</div>
      <div className="text-style-desc mt-3 mb-6">You could add funds to Stability Pool</div>
      <Button onSubmit={() => { navigate('stability-pools') }}>Deposit</Button>
    </div>
  );
};
